import { FC, useState } from "react";
import { BaseModalWindow } from "./BaseModalWindow";
import { useTranslation } from "react-i18next";
import { TextInput } from "../controls/inputs/BaseInput";
import styles from './styles/CancelKizDocWindow.module.scss';

interface ICancelKizDocWindowProps {
    readonly onConfirm: (reason: string) => void;
    readonly onCancel: () => void;
    readonly isLoading?: boolean;
}

export const CancelKizDocModalWindow: FC<ICancelKizDocWindowProps> = (props) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t('modals.cancelKizDocModalWindow.' + value);
    
    const [reason, setReason] = useState<string>('');
    const [error, setError] = useState<string>('');

    const handleConfirm = () => {
        // Валидация: проверяем, что причина не пустая и не состоит из пробелов
        const trimmedReason = reason.trim();
        if (!trimmedReason) {
            setError(baseT('validation.required'));
            return;
        }
        setError('');
        props.onConfirm(trimmedReason);
    };

    const handleCancel = () => {
        setReason('');
        setError('');
        props.onCancel();
    };

    const handleChange = (value: string) => {
        setReason(value);
        if (error) {
            setError('');
        }
    };

    return (
        <BaseModalWindow
            header={baseT("header")}
            ok={{
                onClick: handleConfirm,
                disabled: props.isLoading || !reason.trim(),
                //loading: props.isLoading
            }}
            cancel={{
                onClick: handleCancel,
                disabled: props.isLoading
            }}
        >
            <div className={styles.container}>
                <div className={styles.description}>
                    {baseT("description")}
                </div>
                
                <div className={styles.inputWrapper}>
                    <TextInput
                        className={styles.textArea}
                        value={reason}
                        onChange={handleChange}
                        placeholder={baseT("placeholder")}
                        disabled={props.isLoading}
                    />
                    {error && (
                        <div className={styles.errorMessage}>
                            {error}
                        </div>
                    )}
                    <div className={styles.counter}>
                        {reason.length}/500
                    </div>
                </div>

                <div className={styles.note}>
                    {baseT("note")}
                </div>
            </div>
        </BaseModalWindow>
    );
};
